<div class="user" (clickOutside)="isOpen = false">
  <div class="user-menu-button" (click)="toggle()">
    <img src="/assets/icons/general/user-icon.svg" alt="" />
    <span *ngIf="isLoggedIn" class="user-menu-button-name">{{ user?.firstName }} {{ user?.lastName }} </span>
    <span *ngIf="!isLoggedIn">{{ 'LOGIN.loginBtn' | translate }} </span>
  </div>
  <ul class="user-menu" *ngIf="isOpen" [@slide]>
    <li class="entry">
      <a routerLink="/settings">{{ 'NAVIGATION.navSettings' | translate }}</a>
    </li>
    <li class="entry">
      <a routerLink="/faq">{{ 'NAVIGATION.navFAQ' | translate }}</a>
    </li>
    <li class="entry">
      <a routerLink="/support">{{ 'NAVIGATION.navSupport' | translate }}</a>
    </li>
    <li class="entry">
      <a (click)="logout()">{{ 'NAVIGATION.navLogout' | translate }}</a>
    </li>
  </ul>
</div>



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/header/components/user/user.component.html